<script setup lang="ts">
// Mock of the employer's «Отклики на вакансию» screen; new responses keep arriving while it is on screen.
import { useElementVisibility, useIntervalFn } from '@vueuse/core'

const pool = [
  { name: 'Варвара Орлова', note: 'Бариста · Новосибирск', initials: 'ВО', color: 'bg-rose-400' },
  { name: 'Артём Осипов', note: 'Бариста · Новосибирск', initials: 'АО', color: 'bg-sky-500' },
  { name: 'София Андреева', note: 'Официант · Новосибирск', initials: 'СА', color: 'bg-violet-500' },
  { name: 'Дмитрий Миронов', note: 'Повар · Бердск', initials: 'ДМ', color: 'bg-amber-500' },
  { name: 'Любовь Власова', note: 'Хостес · Новосибирск', initials: 'ЛВ', color: 'bg-emerald-500' },
  { name: 'Матвей Мельников', note: 'Кассир · Новосибирск', initials: 'ММ', color: 'bg-orange-500' },
]

const root = useTemplateRef<HTMLElement>('root')
const visible = useElementVisibility(root)
const offset = ref(0)
const rows = computed(() => Array.from({ length: 6 }, (_, i) => ({
  ...pool[(offset.value + pool.length - i) % pool.length]!,
  key: offset.value - i,
  fresh: i === 0,
  time: ['только что', '12 мин', '40 мин', '2 ч', '3 ч', 'вчера'][i],
})))
const count = computed(() => 12 + offset.value)

const { pause, resume } = useIntervalFn(() => offset.value++, 2600, { immediate: false })
watch(visible, value => value ? resume() : pause())
</script>

<template>
  <div ref="root" class="flex size-full flex-col bg-background text-[13px]">
    <div class="px-4 pb-2 pt-12">
      <p class="text-xl font-semibold">Отклики на вакансию</p>
      <p class="text-sm text-muted-foreground">Бариста · Кофейня «Зерно»</p>
      <div class="mt-4 flex gap-5 border-b text-[15px]">
        <span class="border-b-2 border-primary pb-2 font-semibold">Отклики <span class="tabular-nums text-primary">{{ count }}</span></span>
        <span class="pb-2 text-muted-foreground">Собесы</span>
        <span class="pb-2 text-muted-foreground">Архив</span>
      </div>
    </div>
    <TransitionGroup
      tag="ul"
      class="flex flex-1 flex-col gap-2 overflow-hidden px-3 pt-1"
      enter-from-class="-translate-y-4 opacity-0"
      enter-active-class="transition duration-500"
      move-class="transition duration-500"
    >
      <li v-for="row in rows" :key="row.key" class="relative flex min-h-[79px] items-center gap-3 overflow-hidden rounded-2xl bg-field pl-3">
        <span v-if="row.fresh" class="absolute left-1.5 top-1.5 size-1.5 rounded-full bg-destructive" />
        <span class="flex size-10 shrink-0 items-center justify-center rounded-full text-xs font-semibold text-white" :class="row.color">{{ row.initials }}</span>
        <span class="min-w-0 flex-1 py-2">
          <span class="block truncate text-[17px] font-medium">{{ row.name }}</span>
          <span class="block truncate">{{ row.note }}</span>
          <span class="block truncate text-muted-foreground">{{ row.time }} · {{ row.fresh ? 'Новый' : 'Просмотрено' }}</span>
        </span>
        <span class="flex w-12 self-stretch items-center justify-center bg-muted text-muted-foreground">
          <Icon name="tabler:player-play-filled" class="size-4" />
        </span>
      </li>
    </TransitionGroup>
  </div>
</template>
